import { SdfBox, SdfRadioButton, SdfRadioGroup } from '@synerg/react-components';
import React from 'react';
import {SdfSpotIllustration} from '@synerg/react-components';

function StepOne({selectedRadioBtnIndex, setSelectedRadioBtnIndex}) {

	const onStoreChange = ev => {
		if (ev === 'MP') {
			setSelectedRadioBtnIndex(0);
		}
		if (ev === 'DP') {
			setSelectedRadioBtnIndex(1);
		}
		if (ev === 'B2C') {
			setSelectedRadioBtnIndex(2);
		}
	}

	return (
		<div className="mb-20" style={{marginTop: '4rem'}}>
			<div className="text-heading-05 font-bold mb-10">Partner type</div>

			<div className="flex justify-center gap-8">
				<SdfRadioGroup direction="row">
					<SdfBox
						variant="bordered"
						spacing="default"
						className={selectedRadioBtnIndex === 0 ? 'border-action-primary text-center' : 'text-center'}
						style={{width: '288px', height: '336px'}}
						onClick={() => {
								onStoreChange('MP')
							}}
						>
						<span>
								<div className='flex text-sm mb-16'>
								<SdfRadioButton value="MP" checked={0 === selectedRadioBtnIndex}/>
							</div>
							<SdfSpotIllustration illustrationName='shopping-basket' size='lg'/>
						</span>
						<span className="flex center justify-center">
							<span className="text-heading-03 font-bold">Marketplace partner</span>
						</span>
					</SdfBox>

					<SdfBox
						variant="bordered"
						spacing="default"
						className={selectedRadioBtnIndex === 1 ? 'border-action-primary  p-4 text-center' : ' p-4 text-center'}
						style={{width: '288px', height: '336px'}}
						onClick={() => {
								onStoreChange('DP')
							}}
						>
						<span>
							<div className='flex text-md mb-16'>
								<SdfRadioButton value="DP" checked={1 === selectedRadioBtnIndex}/>
							</div>
							<SdfSpotIllustration illustrationName='people-analytics' size='lg'/>
						</span>
						<span className="flex center justify-center">
							<span className="text-heading-03 font-bold">Datacloud partner</span>
						</span>
					</SdfBox>

					<SdfBox
						variant="bordered"
						spacing="default"
						className={selectedRadioBtnIndex === 2 ? 'border-action-primary  p-4 text-center' : ' p-4 text-center'}
						style={{width: '288px', height: '336px'}}
						onClick={() => {
								onStoreChange('B2C')
							}}
						>
						<span>
							<div className='flex text-md mb-16'>
								<SdfRadioButton value="B2C" checked={2 === selectedRadioBtnIndex}/>
							</div>
							<SdfSpotIllustration illustrationName='person' size='lg'/>
						</span>
						<span className="flex flex-col items-center justify-center">
							<span className="text-heading-03 font-bold">B2C partner</span>
							<div
									className="mt-2 text-sm text-center text-neutral-700"
									style={{ width: '220px', height: '63px' }}
							>
									Solutions that subscribe employees to apps with no ADP client involvement
							</div>
						</span>
					</SdfBox>
				</SdfRadioGroup>
			</div>
		</div>
	)
}

export default StepOne;
